import React from 'react'
import Select from 'react-select'

interface Option {
	value: string | number
	label: string | React.ReactNode
	count?: number
}

interface CustomSelectProps {
	options: Option[]
	value: Option[]
	onChange: (selected: any) => void
	placeholder: string
	isMulti?: boolean
	isClearable?: boolean
	customSelectedColor?: string
	formatOptionLabel?: (option: Option, labelMeta: any) => React.ReactNode
}

const customStyles = {
	control: (provided: any) => ({
		...provided,
		borderRadius: '0.375rem',
		border: '1px solid #ced4da',
		boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
		minHeight: '38px',
		fontSize: '0.875rem',
		'&:hover': {
			borderColor: '#adb5bd',
		},
	}),
	multiValue: (provided: any) => ({
		...provided,
		backgroundColor: '#ff6b6b',
		borderRadius: '0.375rem',
		padding: '0 6px',
	}),
	multiValueLabel: (provided: any) => ({
		...provided,
		color: '#ffffff',
		fontWeight: 500,
		padding: 0,
	}),
	multiValueRemove: (provided: any) => ({
		...provided,
		color: 'rgba(255,255,255,0.9)',
		cursor: 'pointer',
		':hover': {
			backgroundColor: 'rgba(0,0,0,0.08)',
			color: '#ffffff',
		},
	}),
	menu: (provided: any) => ({
		...provided,
		zIndex: 9999,
	}),
	menuPortal: (provided: any) => ({
		...provided,
		zIndex: 9999,
	}),
}

const CustomSelect: React.FC<CustomSelectProps> = ({
	options,
	value,
	onChange,
	placeholder,
	isMulti = false,
	isClearable = false,
	customSelectedColor,
	formatOptionLabel,
}) => {
	const styles = {
		...customStyles,
		multiValue: (provided: any) => ({
			...provided,
			backgroundColor: customSelectedColor || '#ff6b6b',
			borderRadius: '0.375rem',
			padding: '0 6px',
		}),
	}
	return (
		<Select
			isMulti={isMulti}
			isClearable={isClearable}
			options={options}
			value={value}
			onChange={onChange}
			placeholder={placeholder}
			styles={styles}
			formatOptionLabel={formatOptionLabel}
			menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
		/>
	)
}

export default CustomSelect